export default __webpack_public_path__ + "static/media/bell.d6d2afea.svg";